import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "src/app/components/components.module";
import { CustomCurrencyMaskDirective } from "src/app/directives/custom-currency-mask.directive";
import { AngularMaterialModule } from "./angular-material/angular-material.module";
import { DevExtremeModule } from "./dev-extreme/dev-extreme.module";
import { DeviceOrientation } from '@awesome-cordova-plugins/device-orientation/ngx'

import 'devextreme/localization/globalize/number';
import 'devextreme/localization/globalize/date';
import 'devextreme/localization/globalize/currency';
import 'devextreme/localization/globalize/message';

import esMessages from 'devextreme/localization/messages/es.json';
import esCldrData from 'devextreme-cldr-data/es.json';
import supplementalCldrData from 'devextreme-cldr-data/supplemental.json';

import Globalize from 'globalize';


@NgModule({
    providers:[
        DeviceOrientation
    ],
    declarations:[
        CustomCurrencyMaskDirective
    ],
    imports:[
        ComponentsModule,
        HttpClientModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        DevExtremeModule
    ],
    exports:[
        ReactiveFormsModule,
        ComponentsModule,
        AngularMaterialModule,
        CustomCurrencyMaskDirective,
        DevExtremeModule
    ]
})

export class SharedModule { 
    constructor() {
        this.initGlobalize();
        Globalize.locale('es');
      }
    
      initGlobalize() {
        Globalize.load(
            esCldrData,
            supplementalCldrData
        );
        Globalize.loadMessages(esMessages);
    }
  
}